import { NgModule } from "@angular/core";

import { TimePipe } from "./time.pipe";
import { TimerComponent } from "./timer.component";

@NgModule({
	imports: [TimePipe],
	declarations: [TimerComponent],
	exports: [TimerComponent],
})
export class TimerModule {}
